import React, { type FunctionComponent, Fragment, type ComponentType } from 'react'
import { FormattedMessage } from 'react-intl'
import Modal from 'legacy/components/Modal'
import {
  type SandboxOrder,
  type SandboxOrderSimulationEvent,
} from 'domains/connect/components/fulfillment-simulator/utils/types'
import { SimulateOrderEventForm } from 'domains/connect/components/fulfillment-simulator/SimulateOrderEventForm'

interface Props {
  sandboxOrder?: SandboxOrder
  simulationEvent?: SandboxOrderSimulationEvent
  handleClose: () => void
}

export const SimulateOrderEvent: FunctionComponent<Props> = ({ handleClose, ...props }) => (
  <Modal width={1200} height={900} onClose={handleClose}>
    {(Header: ComponentType, Body: ComponentType, Footer: ComponentType) => [
      <Header key="header">
        <FormattedMessage id="connect.fulfillmentSimulator.simulateEvent" />
      </Header>,
      <Body key="body">
        <SimulateOrderEventForm {...props} onSubmit={handleClose} />
      </Body>,
      <Footer key="footer" />,
    ]}
  </Modal>
)
